import { render, staticRenderFns } from "./XFrom.vue?vue&type=template&id=30d5841f&scoped=true"
import script from "./XFrom.vue?vue&type=script&lang=js"
export * from "./XFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d5841f",
  null
  
)

export default component.exports